import React, { useState } from "react";
import { Link } from "react-router-dom";

const Services = () => {
  const COMMISSION_DEPOSIT_URL =
    "https://shop.showbothrows.com/products/commission-consultation-deposit";
  const CREATIVE_SERVICES_EMAIL = "contact@showbothrows.com";
  const [activeCategory, setActiveCategory] = useState("tech");
  const [copiedEmail, setCopiedEmail] = useState(false);

  const cardStyle = {
    padding: "1.5rem",
    backgroundColor: "#fff",
    borderRadius: "8px",
    border: "1px solid #e8e1dc",
  };

  const buttonPrimary = {
    display: "inline-block",
    padding: "0.7rem 1.1rem",
    backgroundColor: "#111",
    color: "white",
    textDecoration: "none",
    borderRadius: "6px",
    border: "1px solid #111",
    cursor: "pointer",
    fontWeight: 700,
  };

  const buttonSecondary = {
    display: "inline-block",
    padding: "0.7rem 1.1rem",
    backgroundColor: "transparent",
    color: "#111",
    textDecoration: "none",
    borderRadius: "6px",
    border: "1px solid #111",
    cursor: "pointer",
    fontWeight: 700,
  };

  const categoryButton = (category) => ({
    padding: "0.65rem 1.1rem",
    borderRadius: "999px",
    border: activeCategory === category ? "2px solid #111" : "1px solid #bbb",
    backgroundColor: activeCategory === category ? "#111" : "transparent",
    color: activeCategory === category ? "white" : "#111",
    cursor: "pointer",
    fontWeight: 700,
  });

  const techServices = [
    {
      title: "0-to-1 Product Builds",
      description:
        "Technical strategy and implementation support for new products, MVPs, prototypes, and founder-led ideas that need to become usable software.",
      examples: [
        "MVP scope and sequencing",
        "Frontend and backend architecture",
        "React product interfaces",
        "Node/TypeScript APIs",
      ],
    },
    {
      title: "1-to-Many Product Scaling",
      description:
        "Support for teams with an existing product that needs stronger systems, cleaner delivery, better reliability, or a plan to scale beyond the first users.",
      examples: [
        "Architecture review",
        "Reliability and observability planning",
        "Technical debt prioritization",
        "Delivery process and team support",
      ],
    },
    {
      title: "Technical Leadership Coverage",
      description:
        "Senior engineering judgment for founders and teams who need a technical partner for planning, tradeoffs, hiring conversations, or project direction.",
      examples: [
        "Founder technical advising",
        "Contractor/vendor evaluation",
        "Roadmap and risk review",
        "Engineering leadership support",
      ],
    },
  ];

  const handleCopyCreativeEmail = async () => {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(CREATIVE_SERVICES_EMAIL);
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = CREATIVE_SERVICES_EMAIL;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }

    setCopiedEmail(true);
    setTimeout(() => setCopiedEmail(false), 2200);
  };

  return (
    <div
      className="services-page"
      style={{ maxWidth: "1200px", margin: "0 auto", padding: "2rem" }}
    >
      <section style={{ marginBottom: "3rem", maxWidth: "840px" }}>
        <p
          style={{
            color: "#6d4c41",
            fontSize: "0.8rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
            marginBottom: "0.75rem",
            textTransform: "uppercase",
          }}
        >
          Current services
        </p>
        <h1
          style={{
            fontSize: "clamp(2.2rem, 5vw, 4rem)",
            lineHeight: 1,
            marginBottom: "1rem",
          }}
        >
          Tech contracts and fashion commissions.
        </h1>
        <p style={{ fontSize: "1.08rem", lineHeight: 1.7, color: "#444" }}>
          I am currently available for scoped tech contract work and custom
          fashion commission consultations. Tech projects can be early 0-to-1
          builds or work that helps an existing product move from one customer,
          workflow, or team into something more scalable.
        </p>
      </section>

      <section style={{ marginBottom: "2.5rem" }}>
        <h2 style={{ fontSize: "1.6rem", marginBottom: "1rem" }}>
          Choose a Service Type
        </h2>
        <div
          style={{
            display: "flex",
            gap: "0.75rem",
            flexWrap: "wrap",
            padding: "1rem",
            backgroundColor: "#f7f4f1",
            borderRadius: "8px",
          }}
        >
          <button
            type="button"
            onClick={() => setActiveCategory("tech")}
            style={categoryButton("tech")}
          >
            Tech Contract Work
          </button>
          <button
            type="button"
            onClick={() => setActiveCategory("fashion")}
            style={categoryButton("fashion")}
          >
            Fashion + Creative Services
          </button>
        </div>
      </section>

      {activeCategory === "tech" ? (
        <section style={{ marginBottom: "3rem" }}>
          <div style={{ marginBottom: "1.5rem", maxWidth: "820px" }}>
            <h2 style={{ fontSize: "2rem", marginBottom: "0.75rem" }}>
              Tech Contract Work
            </h2>
            <p style={{ color: "#444", lineHeight: 1.7 }}>
              I support founders, startups, and product teams that need senior
              engineering direction plus practical execution. Engagements are
              scoped around outcomes, timeline, constraints, and the level of
              hands-on implementation needed.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gap: "1.5rem",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            }}
          >
            {techServices.map((service) => (
              <article key={service.title} style={cardStyle}>
                <h3 style={{ marginBottom: "0.75rem" }}>{service.title}</h3>
                <p style={{ color: "#444", lineHeight: 1.65 }}>
                  {service.description}
                </p>
                <ul style={{ margin: "1rem 0 0", paddingLeft: "1.25rem" }}>
                  {service.examples.map((example) => (
                    <li key={example} style={{ marginBottom: "0.35rem" }}>
                      {example}
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <div
            style={{
              marginTop: "1.5rem",
              padding: "1.5rem",
              backgroundColor: "#f7f4f1",
              borderRadius: "8px",
            }}
          >
            <h3 style={{ marginBottom: "0.75rem" }}>How to inquire</h3>
            <p style={{ maxWidth: "760px", lineHeight: 1.7, color: "#444" }}>
              Send the product goal, where the project is today, the timeline,
              the current stack if one exists, and what kind of support you
              think you need. I will help determine whether the right fit is
              advisory, implementation, technical planning, or leadership
              coverage.
            </p>
            <div
              style={{
                display: "flex",
                gap: "0.75rem",
                flexWrap: "wrap",
                marginTop: "1.25rem",
              }}
            >
              <Link to="/contact" style={buttonPrimary}>
                Contact About Tech Work
              </Link>
              <Link to="/portfolio#tech" style={buttonSecondary}>
                View Tech Portfolio
              </Link>
            </div>
          </div>
        </section>
      ) : (
        <section style={{ marginBottom: "3rem" }}>
          <div style={{ marginBottom: "1.5rem", maxWidth: "820px" }}>
            <h2 style={{ fontSize: "2rem", marginBottom: "0.75rem" }}>
              Fashion + Creative Services
            </h2>
            <p style={{ color: "#444", lineHeight: 1.7 }}>
              Current Both Rows services include custom fashion commission work
              and creative services for projects that need art direction,
              styling, garment-centered storytelling, or brand-aligned visual
              support.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gap: "1.5rem",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            }}
          >
            <article style={cardStyle}>
              <p
                style={{
                  color: "#6d4c41",
                  fontSize: "0.8rem",
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  marginBottom: "0.75rem",
                  textTransform: "uppercase",
                }}
              >
                Available now
              </p>
              <h3 style={{ marginBottom: "0.75rem" }}>
                Commission Consultation Deposit
              </h3>
              <p style={{ color: "#444", lineHeight: 1.7 }}>
                Book this if you are interested in a custom Both Rows piece,
                upcycled design, or project-based garment work. This is the
                first step before final scope and pricing are confirmed.
              </p>
              <ul style={{ margin: "1rem 0 0", paddingLeft: "1.25rem" }}>
                <li>Custom garment concept review</li>
                <li>Fit, material, and timeline discussion</li>
                <li>Creative direction and feasibility check</li>
                <li>Next steps for final commission pricing</li>
              </ul>
              <div style={{ marginTop: "1.25rem" }}>
                <a
                  href={COMMISSION_DEPOSIT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={buttonPrimary}
                >
                  Book Commission Consultation
                </a>
              </div>
            </article>

            <article style={cardStyle}>
              <p
                style={{
                  color: "#6d4c41",
                  fontSize: "0.8rem",
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  marginBottom: "0.75rem",
                  textTransform: "uppercase",
                }}
              >
                Inquiry-based
              </p>
              <h3 style={{ marginBottom: "0.75rem" }}>
                Both Rows Creative Services
              </h3>
              <p style={{ color: "#444", lineHeight: 1.7 }}>
                For creative projects, brand collaborations, styling direction,
                content concepts, garment-focused storytelling, or visual work
                that connects to the Both Rows point of view.
              </p>
              <ul style={{ margin: "1rem 0 0", paddingLeft: "1.25rem" }}>
                <li>Creative direction and concept development</li>
                <li>Styling and garment-centered visual planning</li>
                <li>Brand collaborations and project-based design support</li>
                <li>Content or campaign ideas rooted in fashion storytelling</li>
              </ul>
              <div style={{ marginTop: "1.25rem" }}>
                <p
                  style={{
                    color: "#111",
                    fontWeight: 700,
                    margin: "0 0 0.75rem",
                  }}
                >
                  {CREATIVE_SERVICES_EMAIL}
                </p>
                <button
                  type="button"
                  onClick={handleCopyCreativeEmail}
                  style={buttonSecondary}
                >
                  {copiedEmail ? "Email Copied" : "Copy Email"}
                </button>
              </div>
            </article>
          </div>
        </section>
      )}
    </div>
  );
};

export default Services;
